import MeasurementTableCell from "./MeasurementTableCell";
import OrganizationTableHeader from "./OrganizationTableHeader";
import { Tr } from "./measurementstable.styles";
import { translateDateToPeriod } from "utils/periods";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MeasurementsTableRows(props) {
  var query = props.query,
    measurementsWithMetadata = props.measurementsWithMetadata,
    measure = props.measure,
    dates = props.dates,
    activeFilters = props.activeFilters,
    availableFilters = props.availableFilters,
    amountOfHeaderRows = props.amountOfHeaderRows,
    organizations = props.organizations,
    measureIds = props.measureIds;
  return organizations.map(function (organizationId, rowIdx) {
    var columnEntry = function columnEntry(periodEntry, periodIdx) {
      var periodLabel = translateDateToPeriod(query.periodType, periodEntry.end);
      return measureIds.map(function (measureId, measureIdx) {
        return availableFilters.map(function (filterEntry, filterIdx) {
          return /*#__PURE__*/_jsx(MeasurementTableCell, {
            query: query,
            measureIdx: measureIdx,
            filterEntry: filterEntry,
            filterIdx: filterIdx,
            periodEntry: periodEntry,
            periodIdx: periodIdx,
            measure: measure,
            measureId: measureId,
            activeFilters: activeFilters,
            availableFilters: availableFilters,
            organizationId: organizationId,
            measurementsWithMetadata: measurementsWithMetadata
          }, "".concat(filterEntry.id, "-").concat(periodLabel, "-").concat(measureId));
        });
      });
    };
    return /*#__PURE__*/_jsxs(Tr, {
      "aria-rowindex": amountOfHeaderRows + rowIdx + 1,
      children: [/*#__PURE__*/_jsx(OrganizationTableHeader, {
        query: query,
        rowIdx: rowIdx,
        organizationId: organizationId
      }), dates.map(columnEntry)]
    }, organizationId);
  });
}